import { Injectable, Signal, inject } from '@angular/core';
import { IAuPaginationData } from '@app/shared/ui-components/au-paginator/pagination-page.info';
import { Store } from '@ngrx/store';
import {
	setPaginationData,
	setQueryPaginationOptions,
} from '../file-table/table-state/import-files-table.actions';
import { skip, Subject, take } from 'rxjs';
import { FilesRepoFacade } from '../facades/files-repo.facade';
import { selectPaginationOptions } from '../file-table/table-state/import-files-table.selectors';

@Injectable({
	providedIn: 'root',
})
export class PaginationControlService {
	private readonly store$ = inject(Store);
	private readonly filesRepoFacade = inject(FilesRepoFacade);

	filePaginationData: Signal<IAuPaginationData> = this.store$.selectSignal(
		selectPaginationOptions
	);
	resetPaginationCalled: Subject<void> = new Subject<void>();
	// This serivice is responsible for
	constructor() {}
	handlePaginationUpdateEvent(paginationData: IAuPaginationData) {
		this.store$
			.select(selectPaginationOptions)
			.pipe(skip(1), take(1))
			.subscribe(_ => {
				this.filesRepoFacade.loadImportedFiles();
			});
		this.setPagination(paginationData);
	}
	setPagination(paginationOptions: IAuPaginationData) {
		this.store$.dispatch(
			setQueryPaginationOptions({ paginationData: paginationOptions })
		);
	}

	resetPagination() {
		this.store$.dispatch(setPaginationData({ filesPagination: null }));
		this.resetPaginationCalled.next();
	}
}
